// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ids-calendar-event:not([color]) {
  background-color: var(--ids-calendar-event-color-background);
}
.ids-calendar-event:not([color]):not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-default);
}
.ids-calendar-event:not([color]):not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not([color]):focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}

.ids-calendar-event[color=blue] {
  background-color: var(--ids-calendar-event-color-background-accent-blue);
}
.ids-calendar-event[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-blue);
}
.ids-calendar-event[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event[color=blue]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}

.ids-calendar-event[color=orange] {
  background-color: var(--ids-calendar-event-color-background-accent-orange);
}
.ids-calendar-event[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-orange);
}
.ids-calendar-event[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event[color=orange]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}

.ids-calendar-event[color=purple] {
  background-color: var(--ids-calendar-event-color-background-accent-purple);
}
.ids-calendar-event[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-purple);
}
.ids-calendar-event[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event[color=purple]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}

.ids-calendar-event[color=green] {
  background-color: var(--ids-calendar-event-color-background-accent-green);
}
.ids-calendar-event[color=green]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-green);
}
.ids-calendar-event[color=green]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event[color=green]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}

.ids-calendar-event[color=red] {
  background-color: var(--ids-calendar-event-color-background-accent-red);
}
.ids-calendar-event[color=red]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-red);
}
.ids-calendar-event[color=red]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event[color=red]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}

.ids-calendar-event[color=teal] {
  background-color: var(--ids-calendar-event-color-background-accent-turqoise);
}
.ids-calendar-event[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-turqoise);
}
.ids-calendar-event[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event[color=teal]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}

.ids-calendar-event[color=neutral] {
  background-color: var(--ids-calendar-event-color-background-accent-neutral);
}
.ids-calendar-event[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-neutral);
}
.ids-calendar-event[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event[color=neutral]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}

.ids-calendar-event {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  z-index: var(--ids-z-index-10);
  background: var(--ids-calendar-event-color-background);
  border: 1px solid transparent;
  border-radius: var(--ids-border-radius-2xs);
  color: var(--ids-calendar-event-color-text);
  height: 25px;
  overflow: hidden;
  text-decoration: none;
}
.ids-calendar-event.standalone {
  display: block;
  position: relative;
  height: unset;
}
.ids-calendar-event .calendar-event-content {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: var(--ids-space-3xs) 5px;
}
.ids-calendar-event .calendar-event-content ids-text {
  display: block;
  width: 100%;
  height: 100%;
}
.ids-calendar-event .calendar-event-icon {
  vertical-align: bottom;
  position: relative;
  inset-block-start: -1.5px;
  margin-inline-end: 1px;
  margin-inline-start: -1px;
}
.ids-calendar-event .calendar-event-icon[icon=success-alert] {
  color: var(--ids-calendar-event-color-icon-success);
}
.ids-calendar-event .calendar-event-icon[icon=alert-alert] {
  color: var(--ids-calendar-event-color-icon-alert);
}
.ids-calendar-event .calendar-event-icon[icon=clock] {
  color: var(--ids-calendar-event-color-icon-clock);
}
.ids-calendar-event .calendar-event-icon[icon=pending] {
  color: var(--ids-calendar-event-color-icon-pending);
}
.ids-calendar-event .calendar-event-title {
  line-height: 14px;
}
.ids-calendar-event .calendar-event-title::part(text) {
  text-transform: initial;
}
.ids-calendar-event.is-cutoff {
  border-radius: 3px 3px 0 0;
}
.ids-calendar-event.is-ellipsis .calendar-event-content {
  white-space: nowrap;
}
.ids-calendar-event.reduced-padding .calendar-event-content {
  padding: 0 5px;
}
.ids-calendar-event.reduced-padding .calendar-event-title {
  position: relative;
  top: -1.6px;
}

.ids-calendar-event.all-day {
  top: 1px;
}
.ids-calendar-event.all-day.calendar-event-start, .ids-calendar-event.all-day.calendar-event-continue, .ids-calendar-event.all-day.calendar-event-ends {
  border-radius: 0;
}
.ids-calendar-event.all-day.calendar-event-start {
  border-start-start-radius: 3px;
  border-end-start-radius: 3px;
}
.ids-calendar-event.all-day.calendar-event-continue {
  width: calc(100% + 2px);
  margin-inline-start: -1px;
}
.ids-calendar-event.all-day.calendar-event-ends {
  border-end-end-radius: 3px;
  border-start-end-radius: 3px;
}
.ids-calendar-event.all-day.calendar-event-continue ids-icon, .ids-calendar-event.all-day.calendar-event-ends ids-icon {
  visibility: hidden;
}
.ids-calendar-event.all-day.calendar-event-continue .calendar-event-title, .ids-calendar-event.all-day.calendar-event-ends .calendar-event-title {
  color: var(--ids-color-transparent);
}

.ids-calendar-event.is-month-view {
  position: absolute;
  display: block;
  height: 16px;
}
.ids-calendar-event.is-month-view:not(.all-day) {
  width: calc(100% - 10px);
  margin: 0 5px;
}
.ids-calendar-event.is-month-view.calendar-event-start, .ids-calendar-event.is-month-view.calendar-event-continue, .ids-calendar-event.is-month-view.calendar-event-ends {
  width: calc(100% - 5px);
}
.ids-calendar-event.is-month-view.calendar-event-start {
  margin-inline-start: 5px;
}
.ids-calendar-event.is-month-view.calendar-event-continue {
  width: 100%;
  margin-inline-start: 0;
}
.ids-calendar-event.is-month-view.calendar-event-ends {
  margin-inline-end: 5px;
}
.ids-calendar-event.is-month-view.hidden {
  display: none;
}
.ids-calendar-event.is-month-view .calendar-event-content {
  padding: 0 5px;
  display: flex;
  align-items: center;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-calendar/ids-calendar-event.scss"],"names":[],"mappings":"AAkBA;EAGE,4DAAA;AAnBF;AADE;EACE,8BAAA;EACA,yEAgB2B;AAb/B;AADI;EACE,uEAAA;AAGN;AACE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AACJ;;AAUA;EAGE,wEAAA;AATF;AAjBE;EACE,8BAAA;EACA,6EAsB2B;AAH/B;AAjBI;EACE,uEAAA;AAmBN;AAfE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAiBJ;;AAAA;EAGE,0EAAA;AACF;AAjCE;EACE,8BAAA;EACA,+EA4B2B;AAO/B;AAjCI;EACE,uEAAA;AAmCN;AA/BE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAiCJ;;AAVA;EAGE,0EAAA;AAWF;AAjDE;EACE,8BAAA;EACA,+EAkC2B;AAiB/B;AAjDI;EACE,uEAAA;AAmDN;AA/CE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAiDJ;;AApBA;EAGE,yEAAA;AAqBF;AAjEE;EACE,8BAAA;EACA,8EAwC2B;AA2B/B;AAjEI;EACE,uEAAA;AAmEN;AA/DE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAiEJ;;AA9BA;EAGE,uEAAA;AA+BF;AAjFE;EACE,8BAAA;EACA,4EA8C2B;AAqC/B;AAjFI;EACE,uEAAA;AAmFN;AA/EE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAiFJ;;AAxCA;EAGE,4EAAA;AAyCF;AAjGE;EACE,8BAAA;EACA,iFAoD2B;AA+C/B;AAjGI;EACE,uEAAA;AAmGN;AA/FE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAiGJ;;AAlDA;EAGE,2EAAA;AAmDF;AAjHE;EACE,8BAAA;EACA,gFA0D2B;AAyD/B;AAjHI;EACE,uEAAA;AAmHN;AA/GE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAiHJ;;AA5DA;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,sDAAA;EACA,6BAAA;EACA,2CAAA;EACA,2CAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AA+DF;AA7DE;EACE,cAAA;EACA,kBAAA;EACA,aAAA;AA+DJ;AA5DE;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;AA8DJ;AA5DI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA8DN;AA1DE;EACE,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;AA4DJ;AA1DI;EACE,mDAAA;AA4DN;AAzDI;EACE,iDAAA;AA2DN;AAxDI;EACE,iDAAA;AA0DN;AAvDI;EACE,mDAAA;AAyDN;AArDE;EACE,iBAAA;AAuDJ;AArDI;EACE,uBAAA;AAuDN;AAlDE;EACE,0BAAA;AAoDJ;AAhDI;EACE,mBAAA;AAkDN;AA7CI;EACE,cAAA;AA+CN;AA5CI;EACE,kBAAA;EACA,WAAA;AA8CN;;AAxCA;EACE,QAAA;AA2CF;AAzCE;EAGE,gBAAA;AAyCJ;AArCE;EACE,8BAAA;EACA,4BAAA;AAuCJ;AApCE;EACE,uBAAA;EACA,yBAAA;AAsCJ;AAlCE;EACE,0BAAA;EACA,4BAAA;AAoCJ;AA/BI;EACE,kBAAA;AAiCN;AA9BI;EACE,mCAAA;AAgCN;;AA1BA;EAGE,kBAAA;EACA,cAAA;EACA,YAAA;AA2BF;AAzBE;EACE,wBAAA;EACA,aAAA;AA2BJ;AAxBE;EAGE,uBAAA;AAwBJ;AArBE;EACE,wBAlBa;AAyCjB;AApBE;EACE,WAAA;EACA,sBAAA;AAsBJ;AAnBE;EACE,sBA3Ba;AAgDjB;AAlBE;EACE,aAAA;AAoBJ;AAjBE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAmBJ","sourcesContent":["@mixin event-border-accent($color) {\n  &:not(.calendar-event-continue):not(.calendar-event-ends) {\n    border-inline-start-width: 5px;\n    border-inline-start-color: $color;\n\n    &:focus {\n      border-inline-start-color: var(--ids-calendar-event-color-border-focus);\n    }\n  }\n\n  &:focus {\n    box-shadow: var(--ids-shadow-20);\n    border-color: var(--ids-calendar-event-color-border-focus);\n    outline: none;\n  }\n}\n\n// Calendar Event Type Themes\n.ids-calendar-event:not([color]) {\n  @include event-border-accent(var(--ids-calendar-event-color-border-default));\n\n  background-color: var(--ids-calendar-event-color-background);\n}\n\n.ids-calendar-event[color='blue'] {\n  @include event-border-accent(var(--ids-calendar-event-color-border-accent-blue));\n\n  background-color: var(--ids-calendar-event-color-background-accent-blue);\n}\n\n.ids-calendar-event[color='orange'] {\n  @include event-border-accent(var(--ids-calendar-event-color-border-accent-orange));\n\n  background-color: var(--ids-calendar-event-color-background-accent-orange);\n}\n\n.ids-calendar-event[color='purple'] {\n  @include event-border-accent(var(--ids-calendar-event-color-border-accent-purple));\n\n  background-color: var(--ids-calendar-event-color-background-accent-purple);\n}\n\n.ids-calendar-event[color='green'] {\n  @include event-border-accent(var(--ids-calendar-event-color-border-accent-green));\n\n  background-color: var(--ids-calendar-event-color-background-accent-green);\n}\n\n.ids-calendar-event[color='red'] {\n  @include event-border-accent(var(--ids-calendar-event-color-border-accent-red));\n\n  background-color: var(--ids-calendar-event-color-background-accent-red);\n}\n\n.ids-calendar-event[color='teal'] {\n  @include event-border-accent(var(--ids-calendar-event-color-border-accent-turqoise));\n\n  background-color: var(--ids-calendar-event-color-background-accent-turqoise);\n}\n\n.ids-calendar-event[color='neutral'] {\n  @include event-border-accent(var(--ids-calendar-event-color-border-accent-neutral));\n\n  background-color: var(--ids-calendar-event-color-background-accent-neutral);\n}\n\n.ids-calendar-event {\n  position: absolute;\n  box-sizing: border-box;\n  width: 100%;\n  z-index: var(--ids-z-index-10);\n  background: var(--ids-calendar-event-color-background);\n  border: 1px solid transparent;\n  border-radius: var(--ids-border-radius-2xs);\n  color: var(--ids-calendar-event-color-text);\n  height: 25px;\n  overflow: hidden;\n  text-decoration: none;\n\n  &.standalone {\n    display: block;\n    position: relative;\n    height: unset;\n  }\n\n  .calendar-event-content {\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n    padding: var(--ids-space-3xs) 5px;\n\n    ids-text {\n      display: block;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .calendar-event-icon {\n    vertical-align: bottom;\n    position: relative;\n    inset-block-start: -1.5px;\n    margin-inline-end: 1px;\n    margin-inline-start: -1px;\n\n    &[icon='success-alert'] {\n      color: var(--ids-calendar-event-color-icon-success);\n    }\n\n    &[icon='alert-alert'] {\n      color: var(--ids-calendar-event-color-icon-alert);\n    }\n\n    &[icon='clock'] {\n      color: var(--ids-calendar-event-color-icon-clock);\n    }\n\n    &[icon='pending'] {\n      color: var(--ids-calendar-event-color-icon-pending);\n    }\n  }\n\n  .calendar-event-title {\n    line-height: 14px;\n\n    &::part(text) {\n      text-transform: initial;\n    }\n  }\n\n  // Styles for intraday events\n  &.is-cutoff {\n    border-radius: 3px 3px 0 0;\n  }\n\n  &.is-ellipsis {\n    .calendar-event-content {\n      white-space: nowrap;\n    }\n  }\n\n  &.reduced-padding {\n    .calendar-event-content {\n      padding: 0 5px;\n    }\n\n    .calendar-event-title {\n      position: relative;\n      top: -1.6px;\n    }\n  }\n}\n\n// All day event styles\n.ids-calendar-event.all-day {\n  top: 1px;\n\n  &.calendar-event-start,\n  &.calendar-event-continue,\n  &.calendar-event-ends {\n    border-radius: 0;\n  }\n\n  // first of multi day\n  &.calendar-event-start {\n    border-start-start-radius: 3px;\n    border-end-start-radius: 3px;\n  }\n\n  &.calendar-event-continue {\n    width: calc(100% + 2px);\n    margin-inline-start: -1px;\n  }\n\n  // end of multiday\n  &.calendar-event-ends {\n    border-end-end-radius: 3px;\n    border-start-end-radius: 3px;\n  }\n\n  &.calendar-event-continue,\n  &.calendar-event-ends {\n    ids-icon {\n      visibility: hidden;\n    }\n\n    .calendar-event-title {\n      color: var(--ids-color-transparent);\n    }\n  }\n}\n\n// Month View Styles\n.ids-calendar-event.is-month-view {\n  $month-margin: 5px;\n\n  position: absolute;\n  display: block;\n  height: 16px;\n\n  &:not(.all-day) {\n    width: calc(100% - ($month-margin * 2));\n    margin: 0 $month-margin;\n  }\n\n  &.calendar-event-start,\n  &.calendar-event-continue,\n  &.calendar-event-ends {\n    width: calc(100% - $month-margin);\n  }\n\n  &.calendar-event-start {\n    margin-inline-start: $month-margin;\n  }\n\n  &.calendar-event-continue {\n    width: 100%;\n    margin-inline-start: 0;\n  }\n\n  &.calendar-event-ends {\n    margin-inline-end: $month-margin;\n  }\n\n  &.hidden {\n    display: none;\n  }\n\n  .calendar-event-content {\n    padding: 0 5px;\n    display: flex;\n    align-items: center;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
